import { ITelemetryItem } from '@microsoft/applicationinsights-web';

import { BROWSER_EXTENSION_ERROR_ORIGIN } from '../constants/error-origin.constants';
import { findOriginFrame, tagExceptionOrigin } from './exception-origin.utils';

const browserExtensionSchemes = ['chrome-extension://', 'moz-extension://', 'safari-extension://', 'safari-web-extension://'];

export function isBrowserExtensionStack(stack: string | null | undefined): boolean {
  if (typeof stack !== 'string') {
    return false;
  }
  return containsBrowserExtensionScheme(findOriginFrame(stack));
}

export function tagBrowserExtensionException(item: ITelemetryItem): void {
  tagExceptionOrigin(item, BROWSER_EXTENSION_ERROR_ORIGIN, containsBrowserExtensionScheme, isBrowserExtensionStack);
}

export function containsBrowserExtensionScheme(value: string): boolean {
  return browserExtensionSchemes.some((scheme) => value.includes(scheme));
}
